<div class="titulo">
    <p><span>2. </span>Ingresa tus datos</p>
</div>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="fill">
        <mat-label>Nombre</mat-label>
        <input name="firstname" appOnlyLetters formControlName="name" type="text" matInput required
               autocomplete="off">
        <mat-error *ngIf="form.controls.name.hasError('required')">Campo requerido</mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Apellido Paterno</mat-label>
        <input name="lastname" appOnlyLetters formControlName="lastName" type="text" matInput required
               autocomplete="off">
        <mat-error *ngIf="form.controls.lastName.hasError('required')">Campo requerido
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Apellido Materno</mat-label>
        <input appOnlyLetters formControlName="secondLastName" type="text" matInput
               autocomplete="off">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Correo electrónico</mat-label>
        <input name="email" appToLowercase formControlName="email" type="text" matInput required autocomplete="off">
        <mat-error *ngIf="form.controls.email.hasError('required')">Campo requerido</mat-error>
        <mat-error
                *ngIf="!form.controls.email.hasError('required') && form.controls.email.hasError('emailFormat')">
            Correo
            inválido
        </mat-error>
    </mat-form-field>
    <mat-radio-group [formControl]="tipoCuenta" required>
        <label> <strong>¿Cómo piensas usar FAD?</strong></label>
        <mat-radio-button [value]="false">¿Para firmar documentos personales?</mat-radio-button>
        <mat-radio-button [value]="true">¿Para firmar documentos de mi empresa?</mat-radio-button>
    </mat-radio-group>
    <mat-checkbox [(ngModel)]="acepptTerms" [ngModelOptions]="{standalone: true}">
        Acepto los <a
            [routerLink]="['/terminos-y-condiciones']" target="_blank">Términos y condiciones</a>, así como la
        <a [routerLink]="['/aviso-de-privacidad']" target="_blank">Política de privacidad</a>
    </mat-checkbox>
    <button *ngIf="valid" class="submit-button" type="submit">
        <p>CREAR CUENTA</p>
    </button>
    <button class="submit-button" [disabled]="form.invalid || !acepptTerms"
            [ngClass]="{'disabled':form.invalid  || !acepptTerms }">
        <p>CREAR CUENTA</p>
    </button>
</form>

